/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Debug_Info_LabelInputs */

const fr_settings_show_debug_info_label = /** @type {(inputs: Settings_Show_Debug_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode débogage`)
};

const en_settings_show_debug_info_label = /** @type {(inputs: Settings_Show_Debug_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debug mode`)
};

/**
* | output |
* | --- |
* | "Debug mode" |
*
* @param {Settings_Show_Debug_Info_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_debug_info_label = /** @type {((inputs?: Settings_Show_Debug_Info_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Debug_Info_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_debug_info_label(inputs)
	return en_settings_show_debug_info_label(inputs)
});